// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const SET_WORK_ORDERS_DATA = 'SET_WORK_ORDERS_DATA'
export const SET_PCN_DATA = 'SET_PCN_DATA'
export const SET_PCN_RENEWAL_DATA = 'SET_PCN_RENEWAL_DATA'
export const SET_PCN_RENEWAL_HIGHLIGHTED_IDS = 'SET_PCN_RENEWAL_HIGHLIGHTED_IDS'
export const SET_RENEWAL_ADMIN_DATA = 'SET_RENEWAL_ADMIN_DATA'
export const SET_RENEWAL_ADMIN_HIGHLIGHTED_IDS = 'SET_RENEWAL_ADMIN_HIGHLIGHTED_IDS'
export const SET_FILING_STATUS_DATA = 'SET_FILING_STATUS_DATA'
export const SET_BULK_REMINDER_SUMMARY_EMAIL = 'SET_BULK_REMINDER_SUMMARY_EMAIL'
